import { usePlanMainTarget as useMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanMainTarget = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();

	const { mainTarget } = viewModel;

	return useMainTarget({ mainTarget, onSetViewModel });
};
